module.exports = __webpack_public_path__ + "img/11087928_L.9389dd1a.png";